import React, { FunctionComponent } from 'react';
import { Box, Typography, useTheme } from '@material-ui/core';
import keyFeaturesStyles from './keyFeaturesStyles';
import { GetCustomizeCarModel_customizeCar_car_keyFeatures } from '../../../../../graphql/queries/__generated__/GetCustomizeCarModel';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';
import LimitedKeyFeatures from './LimitedKeyFeatures';
import { KeyFeature } from './KeyFeature';

export interface IKeyFeaturesProps {
  keyFeatures: GetCustomizeCarModel_customizeCar_car_keyFeatures[];
}

const KeyFeatures: FunctionComponent<IKeyFeaturesProps> = ({ keyFeatures }) => {
  const styles = keyFeaturesStyles();

  const {
    spc: {
      customise: { showAllKeyFeatures },
    },
  } = useTheme<ISpcTheme>();

  if (!keyFeatures?.length) {
    return null;
  }

  return (
    <Box className={styles.container} data-test="customise:featuresContent">
      <Typography variant="body1" className={styles.title} data-test="customise:featuresTitle">
        <Translation id="trans__configurator__customise_page_variant_section__features_subtitle" />
      </Typography>
      {!!showAllKeyFeatures ? (
        keyFeatures.map((feature: GetCustomizeCarModel_customizeCar_car_keyFeatures) => (
          <KeyFeature key={feature.id} shortname={feature.shortname} />
        ))
      ) : (
        <LimitedKeyFeatures keyFeatures={keyFeatures} />
      )}
    </Box>
  );
};

export default KeyFeatures;
